function obtainSessionKey(sub1, sub2) {
    let sub1Len = sub1.length;
    let sub2Len = sub2.length;
    
    let s1 = sub1.slice(0, sub1Len);
    let s2 = sub2.slice(0, sub2Len);
    
    let minLen = Math.min(sub1Len, sub2Len);
    let s1Prefix = s1.slice(0, minLen);
    let s2Prefix = s2.slice(0, minLen);
    let ret;
    
    if (s1Prefix < s2Prefix) {
        ret = -1;
    } else if (s1Prefix > s2Prefix) {
        ret = 1;
    } else {
        ret = 0;
    }
    
    while (true) {
        if (ret < 0) {
            return s1 + '+' + s2;
        } else if (ret > 0) {
            return s2 + '+' + s1;
        } else {
            if (sub1Len < sub2Len) {
                ret = -1;
                continue;
            }
            if (sub1Len > sub2Len) {
                ret = 1;
                continue;
            }
            console.warn(`Unexpected situation that sub-names are equal: ${s1} = ${s2}`);
            ret = -1;
            continue;
        }
    }
}

export default obtainSessionKey;